<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("edit") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-lg-6">
              <upload-image-direct
                @loading="btnIsLoading = $event"
                @inputChanged="uplodeImg_1"
                placeHolder="صورة القسم"
                :data_src="data.preview_ar"
                title="الصورة عربي"
                model="sliders"
              ></upload-image-direct>
            </div>
            <div class="col-lg-6">
              <upload-image-direct
                @loading="btnIsLoading = $event"
                @inputChanged="uplodeImg_2"
                placeHolder="صورة القسم"
                title="الصورة انجليزي"
                :data_src="data.preview_en"
                model="sliders"
              ></upload-image-direct>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isArabic"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.ar.name"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.name_ar") }}
                </label>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isEnglish"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.en.name"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.name_en") }}
                </label>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.desc_ar") }}
                </label>
                <textarea
                  @keypress="isArabic"
                  class="form-control"
                  rows="5"
                  v-model="data.ar.desc"
                ></textarea>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.desc_en") }}
                </label>
                <textarea
                  @keypress="isEnglish"
                  class="form-control"
                  rows="5"
                  v-model="data.en.desc"
                ></textarea>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label"> النوع </label>
                <multiselect
                  v-model="data.type"
                  :options="types"
                  label="name"
                  @input="getStores()"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>
            <template v-if="data.type">
              <div class="col-lg-6 py-0" v-if="data.type.id == 'internal'">
                <div class="input_wrapper top_label">
                  <label class="form-label"> المتاجر </label>
                  <multiselect
                    v-model="data.store"
                    :options="stores"
                    @input="getMeals()"
                    label="name"
                    track-by="id"
                    placeholder=" "
                    :multiple="false"
                    :searchable="true"
                    :allow-empty="false"
                    :show-labels="false"
                  ></multiselect>
                </div>
              </div>
              <div class="col-lg-6 py-0" v-if="data.type.id == 'internal'">
                <div class="input_wrapper top_label">
                  <label class="form-label"> الوجيات </label>
                  <multiselect
                    v-model="data.meals"
                    :options="meals"
                    label="name"
                    track-by="id"
                    placeholder=" "
                    :multiple="true"
                    :searchable="true"
                    :allow-empty="false"
                    :show-labels="false"
                  ></multiselect>
                </div>
              </div>
              <div class="col-lg-6 py-0" v-if="data.type.id == 'external'">
                <div class="input_wrapper top_label">
                  <input
                    @keypress="isEnglish"
                    type="url"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    v-model.trim="data.link"
                  />
                  <label for="name_input" class="form-label">
                    {{ $t("forms.labels.link") }}
                  </label>
                </div>
              </div>
            </template>
            <!-- <div class="col-lg-12 py-0">
              <v-checkbox
                :label="$t('forms.labels.is_active')"
                v-model="data.is_active"
                color="indigo lighten-2"
              ></v-checkbox>
            </div> -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="button_style_1">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",
  props: ["id"],
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.main_slider.title"),
          disabled: false,
          href: "/slider/show-all",
        },
        {
          text: this.$t("breadcrumb.main_slider.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== create_data
      data: {
        image_ar: null,
        preview_ar: null,
        preview_en: null,
        image_en: null,
        ar: {
          name: null,
          desc: null,
        },
        en: {
          name: null,
          desc: null,
        },
        type: null,
        link: null,
        meals: null,
        store: null,
        // ordering: null,
        // is_active: false,
        hex: "#000000",
        // link: null,
        // category: null,
        // type: "category",
        // bunnerType: "",
      },
      categories: [],
      types: [
        { name: "خارجي", id: "external" },
        // { name: "داخلي", id: "internal" },
        { name: "ثابت", id: "static" },
      ],
      meals: [],
      stores: [],
    };
  },

  methods: {
    getData() {
      this.$axios.get(`slider/${this.id}`).then((res) => {
        this.getStores();
        this.data.preview_ar = res.data.data.image_ar;
        this.data.preview_en = res.data.data.image_en;
        this.data.ar.name = res.data.data.ar.name;
        this.data.ar.desc = res.data.data.ar.description;
        this.data.en.name = res.data.data.en.name;
        this.data.en.desc = res.data.data.en.description;
        this.data.link = res.data.data.link;
        this.data.type = this.types.find((el) => el.id == res.data.data.type);
        this.data.meals = res.data.data.meals;
      });
    },
    // Uplode Image
    uplodeImg_1(obj) {
      this.data.image_ar = obj;
    },
    uplodeImg_2(obj) {
      this.data.image_en = obj;
    },
    getMeals() {
      this.$axios.get("meal_not_paginated").then((res) => {
        this.meals = res.data.data.map((item) => {
          return {
            id: item.id,
            name: item.name,
          };
        });
      });
    },
    getStores() {
      this.$axios.get("store_not_paginated").then((res) => {
        this.stores = res.data.data.map((item) => {
          return {
            id: item.id,
            name: item.full_name,
          };
        });
      });
    },
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      if (
        (!this.data.ar.name || !this.data.en.name) &&
        this.radioButtonsValue == "name"
      ) {
        this.$iziToast.error({
          timeout: 5000,
          message: this.$t("forms.validation.name"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
      } else if (!this.data.ar.desc || !this.data.en.desc) {
        this.$iziToast.error({
          timeout: 5000,
          message: this.$t("forms.validation.desc"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
      } else if (!this.data.type) {
        this.$iziToast.error({
          timeout: 5000,
          message: " النوع مطلوب",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
      } else if (this.data.type.id == "internal" && !this.data.meals.length) {
        this.$iziToast.error({
          timeout: 5000,
          message: "يرجي اختيار وجبات ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
      } else if (this.data.type.id == "external" && !this.data.link) {
        this.$iziToast.error({
          timeout: 5000,
          message: "الرابط مطلوب",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      //
      if (this.data.image_ar) {
        submit_data.append("image_ar", this.data.image_ar);
      }
      if (this.data.image_en) {
        submit_data.append("image_en", this.data.image_en);
      }
      submit_data.append("ar[name]", this.data.ar.name);
      submit_data.append("en[name]", this.data.en.name);
      if (this.data.type.id == "external") {
        submit_data.append("link", this.data.link);
      }
      if (this.data.type.id == "internal")
        this.data.meals.forEach((el, index) => {
          submit_data.append(`meals_ids[${index}]`, el.id);
        });
      if (this.data.en.desc) {
        submit_data.append("en[description]", this.data.en.desc);
      }
      if (this.data.ar.desc) {
        submit_data.append("ar[description]", this.data.ar.desc);
      }

      // submit_data.append("ordering", this.data.ordering || "");
      // if (this.radioButtonsValue == "color") {
      //   submit_data.append("color", this.data.hex || "");
      // }
      submit_data.append("type", this.data.type.id);
      submit_data.append("_method", "PUT");

      // if (this.data.bunnerType != "") {
      //   submit_data.append("type", this.data.bunnerType.id);
      // }
      // if (this.data.category) {
      //   submit_data.append("category_id", this.data.category.id);
      // }

      // submit_data.append("is_active", +this.data.is_active);

      this.$axios({
        method: "POST",
        url: `slider/${this.id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 5000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/slider/show-all" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 5000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },

    // getCategories() {
    //   this.$axios({
    //     method: "GET",
    //     url: `category/all`,
    //   }).then((res) => {
    //     this.categories = res.data.data.map((item) => {
    //       return {
    //         id: item.id,
    //         name: item.name,
    //       };
    //     });
    //   });
    // },
  },

  mounted() {
    // this.getMeals();
    this.getData();
    // this.getCategories();
  },
};
</script>
